export const FieldError = {
  NAME_EXISTS: 'NAME_ALREADY_EXISTS',
  NAME_WITH_TYPE_EXISTS: 'NAME_WITH_TYPE_ALREADY_EXISTS',
  BUSINESS_ID_NUMBER_EXISTS: 'BUSINESS_ID_NUMBER_ALREADY_EXISTS',
  EMAIL_EXISTS: 'EMAIL_ALREADY_EXISTS',
  VIN_EXISTS: 'VIN_ALREADY_EXISTS',
  LICENSE_PLATE_NUMBER_EXISTS: 'LICENSE_PLATE_NUMBER_ALREADY_EXISTS',
  REFERENCE_NUMBER_EXISTS: 'REFERENCE_NUMBER_ALREADY_EXISTS',
  TEMPLATE_ID_WITH_TYPE_EXISTS: 'TEMPLATE_ID_WITH_TYPE_ALREADY_EXISTS',
};
